import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { setModule } from 'store/actions/ui';
import Loading from './Loading';
import { getModuleFromUrl } from 'utils/getUrlParams';

const AppInit = props => {
  const module = getModuleFromUrl();

  useEffect(() => {
    if (module) props.setModule(module);
  }, [module]);

  const uiState = useSelector(state => state.ui);
  if (module && !uiState.module) return <Loading />;
  return props.children;
};
export default connect(null, { setModule })(AppInit);

AppInit.propTypes = {
  setModule: PropTypes.any,
  children: PropTypes.any
};
